var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pixelUrl)?_c('img',{staticStyle:{"display":"none","border-style":"none"},attrs:{"height":"1","width":"1","alt":"","src":_vm.pixelUrl}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }